define('home/templates/profileAlertPrivate',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"alert alert--brand text-small\">\n<span class=\"icon-lock icon-tiny icon__position -inline\"></span>\n"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"This user's profile has been set to private.",{"name":"gettext","hash":{},"data":data}))
    + "\n</div>\n";
},"useData":true})

});
